import { Box } from '@mui/material';
import { ScreenReadersOnly } from '@customink/pigment-react';
import { useTaxExemption, useTaxExemptionPortal } from '~/adapters/services/accounts/tax-exemptions/hooks';
import { Loader } from '~/components/Loader/loader';
import { TaxExemptionCertificateList } from '~/pages/Settings/tabs/TaxExemption/components/Certificate/TaxExemptionCertificateList';
import { TaxExemptionsPortalLinks } from '~/pages/Settings/tabs/TaxExemption/components/Portal/Links/TaxExemptionsPortalLinks';
import { TaxExemptionsVerifyStatusButton } from '~/pages/Settings/tabs/TaxExemption/components/Portal/Verify/TaxExemptionsVerifyStatusButton';
import { usePage } from '~/adapters/browser/usePage';
import { Title } from '~/pages/Settings/title';
import { AdminTaxExemptionInfoBox } from '~/pages/Settings/tabs/TaxExemption/components/AdminTaxExemptionInfoBox';

const ScreenReaderHeading = () => (
    <ScreenReadersOnly>
        <h2>Tax Exemption</h2>
    </ScreenReadersOnly>
);

export function TaxExemptionTab() {
    usePage({ title: Title, reportPath: '/accounts/tax_exemption' });

    const { isLoading: isPortalLoading, data: portalData } = useTaxExemptionPortal();

    const { isLoading: isTaxExemptionLoading, data: taxExemptionData } = useTaxExemption();
    const mergedTaxExemptions = [
        ...(taxExemptionData?.taxCertificates.current ?? []),
        ...(taxExemptionData?.taxCertificates.expired ?? []),
    ]; // skipping useMemo for simplicity; this component isn't rendered often

    if (isPortalLoading || isTaxExemptionLoading) {
        return <Loader title="Loading..." devLabel="Tax exemption API" />;
    }

    const hasTaxExemptions = mergedTaxExemptions.length > 0;
    if (hasTaxExemptions) {
        return (
            <Box>
                <ScreenReaderHeading />
                <TaxExemptionsPortalLinks portalData={portalData} />
                <TaxExemptionCertificateList taxExemptions={mergedTaxExemptions} />
            </Box>
        );
    }

    // The ECMS API won't tell us whether the exemption approval process is in process. Thus we assume that if there are
    // portalData (info from accounts-service) but no taxExemptions (from ECMS), the exemption approval is still in progress.
    return (
        <>
            <ScreenReaderHeading />
            <TaxExemptionsVerifyStatusButton portalUrl={portalData?.portalUrl ?? null} />
            <AdminTaxExemptionInfoBox portalData={portalData} />
        </>
    );
}
